import React from "react";
import "./styles.css";

const ViewerAr = () => {
  return <button id="btnAr"> Add to the cart</button>;
};

export default ViewerAr;
